import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction, TOptions } from 'i18next';
import { useScope } from 'contexts/scopeContext';

type ProgramTranslationOptions = TOptions & {
	context?: string;
};

const COACHING_CONTEXT = 'coaching';

export const useProgramTranslationStatic = ({
	programContext,
	lng,
}: {
	programContext?: string | null;
	lng?: string | null;
}) => {
	const translation = useTranslation();
	const { t } = translation;

	const tProgram = useCallback(
		(key: string, options?: ProgramTranslationOptions) => {
			if (!programContext || options?.context) {
				return t(key, { ...options, lng: lng || undefined });
			}

			return t(key, {
				...options,
				context: programContext,
				lng: lng || undefined,
			});
		},
		[programContext, lng, t]
	) as unknown as TFunction;

	return {
		...translation,
		tProgram,
		programContext,
	};
};

export const useProgramTranslation = () => {
	const { currentProgram } = useScope();
	const programContext = currentProgram?.programType === COACHING_CONTEXT ? COACHING_CONTEXT : undefined;
	const programTranslationHookResult = useProgramTranslationStatic({ programContext });
	return programTranslationHookResult;
};
